export const gtmChangeAttributeEvent = (typeName: string, value: string) => ({
  event: 'product-page-dropdown',
  dropdown: typeName,
  value,
});

export default gtmChangeAttributeEvent;
